module.exports = __webpack_public_path__ + "img/2010.10.0293e10d.png";